<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="modal_id"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot v-if="formData && formData.id" name="modalTitle"
              >検査資料を編集</slot
            >
            <slot v-else name="modalTitle">検査資料を追加</slot>
          </h5>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-12">
              <label for="inspection_name" class="form-label">検査資料名</label>
              <input
                v-model="formData.name"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': v$.formData.name.$error,
                }"
                id="inspection_name"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            閉じる
          </button>
          <button
            type="button"
            class="btn btn-dark"
            v-on:click.prevent="insert()"
          >
            <slot name="submitButton">保存</slot>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { Modal } from 'bootstrap/dist/js/bootstrap.esm.min.js'
import store from '../store'

export default {
  name: 'InspectionForm',
  components: {},

  setup() {
    return { v$: useVuelidate() }
  },

  emits: ['insertInspection'],

  data() {
    return {
      modal: null,
      formData: {},
    }
  },
  computed: {
    modal_id: function () {
      let chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let rand_str = ''
      for (let i = 0; i < 8; i++) {
        rand_str += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return 'form-modal-' + rand_str
    },
  },
  validations() {
    return {
      formData: {
        name: { required },
      },
    }
  },

  mounted() {
    this.modal = new Modal(document.getElementById(this.modal_id))
    document
      .getElementById(this.modal_id)
      .addEventListener('hidden.bs.modal', this.cleanForm)
  },
  beforeUnmount() {
    this.modal.hide()
  },

  methods: {
    show(inspection = {}) {
      this.formData = Object.assign({}, inspection)
      this.modal.show()
    },
    async insert() {
      const result = await this.v$.$validate()
      if (!result) {
        return
      }
      const data = await store.dispatch('inspection/postOrPatch', this.formData)
      this.$emit('insertInspection', data)
      this.modal.hide()
    },
    cleanForm() {
      this.v$.$reset()
      this.formData = {}
    },
  },
}
</script>
